export const html = `<div><UploadMedia multiple /></div>
<div><UploadMedia type="image" accept="image/jpeg, image/gif, image/png" multiple /></div>
<div><UploadMedia type="video" accept="video/mp4" multiple /></div>
`
